






















import Vue from 'vue'
import { convertSeconds, isDisplayShow } from '@/utils/index'
import { ProductionStatisticsServiceProxy, ProductionPlanOrderSearchDTO } from '@/service-proxies/app-v2/coproduction.service-proxies'
import { TenantBizFieldServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const productionStatisticsServiceProxy = new ProductionStatisticsServiceProxy()
const tenantBizFieldServiceProxy = new TenantBizFieldServiceProxy()

export default Vue.extend({
  name: '',
  components: {
  },
  data() {
    return {
      data: [],
      loading: false,
      productColums: [], // 产品表格的字段
      showColumns: [],
      tableScrollWidth: 1700,
      pageSize: 9999,
      currentPage: 1,
      totalContent: 0, // 表格总数
    }
  },
  props: {
     planId: {
      type: String,
      default: ''
    },
    typeId: {
      type: String,
      default: ''
    },
    tableScrollHeight: {
      type: Number,
      default: 200
    }
  },
  created() {
    this.load()
  },
  watch: {
    'planId'(val) {
      if (val) {
        this.load()
      } else {
        this.data = []
      }
    },
  },
  methods: {
    load() {
      this.getTableColumn()
      this.selectedRowKeys = []
      this.loading = true
      productionStatisticsServiceProxy.getProductionOrderProcessScheduleAnalysis(this.currentPage, new ProductionPlanOrderSearchDTO({
        planId: this.planId,
        status: [1,2,3,4,5]
      }), this.pageSize).then(res => {
        this.loading = false
        this.data = res
        if (this.data.length > 0) {
          this.data.forEach(response => {
            response.processCollectionTime = convertSeconds(response.processCollectionTime)
            response.processReportTime = convertSeconds(response.processReportTime)
            response.standardTime = convertSeconds(response.standardTime)
            response.workTimeDiference1 = convertSeconds(response.workTimeDiference1)
            response.workTimeDifference2 = convertSeconds(response.workTimeDifference2)
          })
        }
      })
    },

    // 获取指定业务的字段列表
    async getTableColumn() {
      this.productColums = []
      this.productColums = await tenantBizFieldServiceProxy.getTenantBizField('stat_process_order', this.typeId)
      this.handleColumns()
    },
    handleColumns() {
      this.showColumns = []
      if (!this.productColums || !this.productColums.length) {
        return
      }
      // 字段排序
      this.productColums.sort((a, b) => {
        return a.sort - b.sort
      })
      // 字段显隐
      let columns = []
      const timeArr = ['planStartTime', 'planEndTime']
      this.productColums.map(item => {
        if (isDisplayShow(item.isDisplay, 2)) {
          // 自定义字段：产品类型
          const temp: any = {
            title: item.title,
            key: item.code,
            dataIndex: item.code,
            ellipsis: true
          }
          if (temp.key === 'orderCode') {
            temp.width = 160
          } else if (timeArr.includes(temp.key)) {
            temp.width = 150
          } else {
            temp.width = (temp.title.length + 1) * 20
          }
          columns.push(temp)
        }
      })
      this.showColumns = [...columns]
      let num = this.productColums.filter(item => isDisplayShow(item.isDisplay, 2)).length
      this.tableScrollWidth = num * 100
      console.log('showColumns:', this.showColumns)
    },
  }
})
